import React from 'react';
import { List } from 'immutable';
import config from 'react-global-configuration';

import NodeLandingPageFull from './Full';
import NodeLandingPageCampaign from './Campaign';
import NodeLandingPageMaatjes from './Maatjes';

import { MAATJES_DOMAIN } from '../../../config/constants';

const NodeLandingPage = (props) => {
  const { entity } = props;
  const currentDomain = config.get('CURRENT_DOMAIN');

  switch (currentDomain) {
    case MAATJES_DOMAIN:
      return <NodeLandingPageMaatjes {...props} />;
    default:
      if (entity.getIn(['field_campaign'], List()).size > 0) {
        return <NodeLandingPageCampaign {...props} />;
      }
      return <NodeLandingPageFull {...props} />;
  }
};

export default NodeLandingPage;
